import Tooltip from '../ui-control/Tooltip';
import {
  neutralInlineButtonClasses,
  rowMoveMenuClasses,
  rowMoveMenuItemClasses,
  rowMoveMenuWrapperClasses,
} from './lifecareStudioClasses';
import useLifecareStudioRowMoveMenu from '../../hooks/useLifecareStudioRowMoveMenu';

const MOVE_ROW_TOOLTIP = 'Move this row to another table';
const NO_TARGETS_TOOLTIP = 'No other table to move this row to';

const LifecareStudioRowMoveMenu = ({ moveTargets = [], onMoveRow }) => {
  const { isOpen, anchorRef, toggleMenu, selectTarget } = useLifecareStudioRowMoveMenu({
    onSelectTarget: onMoveRow,
  });
  const hasTargets = moveTargets.length > 0;

  return (
    <div ref={anchorRef} className={rowMoveMenuWrapperClasses}>
      <Tooltip title={hasTargets ? MOVE_ROW_TOOLTIP : NO_TARGETS_TOOLTIP} placement="left">
        <button
          type="button"
          className={neutralInlineButtonClasses}
          onClick={toggleMenu}
          disabled={!hasTargets}
          aria-label="Move row to another table"
          aria-haspopup="menu"
          aria-expanded={isOpen}
        >
          <i className="fa fa-arrow-right" />
        </button>
      </Tooltip>
      {isOpen && hasTargets && (
        <div className={rowMoveMenuClasses} role="menu">
          {moveTargets.map(({ index, title }) => (
            <button
              key={index}
              type="button"
              role="menuitem"
              className={rowMoveMenuItemClasses}
              onClick={() => selectTarget({ targetSubsectionIndex: index })}
            >
              {title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LifecareStudioRowMoveMenu;
